export default __webpack_public_path__ + "static/char-v-12-4d86022dd3e47fb83f72518417e2bf8a.png";